// Item 20: consumer-facing UI label localization (EN / AR / FR / SW).
// Layers: dashboard `canvas.language` override  >  effective regional default  >  browser.
const EN = {
  filters: "Filters", apply: "Apply", applied: "Applied", reset: "Reset", clear_all: "Clear all",
  loading_dashboard: "Loading dashboard", no_data: "No data", retry: "Retry",
  no_rows_match: "No rows match the column filters.", rows: "rows", of: "of", page: "Page",
  grand_total: "Grand total", total: "Total", target: "Target", achieved: "Achieved",
  trend: "Trend", search: "Search", select_all: "Select all", all: "All",
  export: "Export", refresh: "Refresh", last_updated: "Last updated",
  // shell / navigation
  dashboards: "Dashboards", data_sources: "Data Sources", metrics: "Metrics", alerts: "Alerts", reports: "Reports",
  admin_console: "Admin Console", developer: "Developer", settings: "Settings", help: "Help", sign_out: "Sign out",
  sites: "Sites", new_dashboard: "New Dashboard", save: "Save", cancel: "Cancel", close: "Close", delete: "Delete",
  edit: "Edit", share: "Share", publish: "Publish", preview: "Preview", back: "Back", skip_to_content: "Skip to main content",
  clear_filter: "Clear filter", filter: "Filter", sort_column: "Sort column", regional_settings: "Regional settings",
};
const DICTS = {
  en: EN,
  ar: {
    filters: "عوامل التصفية", apply: "تطبيق", applied: "مُطبَّق", reset: "إعادة تعيين", clear_all: "مسح الكل",
    loading_dashboard: "جارٍ تحميل لوحة المعلومات", no_data: "لا توجد بيانات", retry: "إعادة المحاولة",
    no_rows_match: "لا توجد صفوف مطابقة لعوامل التصفية.", rows: "صفوف", of: "من", page: "صفحة",
    grand_total: "الإجمالي الكلي", total: "الإجمالي", target: "الهدف", achieved: "المُحقَّق",
    trend: "الاتجاه", search: "بحث", select_all: "تحديد الكل", all: "الكل",
    export: "تصدير", refresh: "تحديث", last_updated: "آخر تحديث",
    dashboards: "لوحات المعلومات", data_sources: "مصادر البيانات", metrics: "المقاييس", alerts: "التنبيهات", reports: "التقارير",
    admin_console: "وحدة الإدارة", developer: "المطوّر", settings: "الإعدادات", help: "مساعدة", sign_out: "تسجيل الخروج",
    sites: "المواقع", new_dashboard: "لوحة جديدة", save: "حفظ", cancel: "إلغاء", close: "إغلاق", delete: "حذف",
    edit: "تعديل", share: "مشاركة", publish: "نشر", preview: "معاينة", back: "رجوع", skip_to_content: "الانتقال إلى المحتوى الرئيسي",
    clear_filter: "مسح عامل التصفية", filter: "تصفية", sort_column: "ترتيب العمود", regional_settings: "الإعدادات الإقليمية",
  },
  fr: {
    filters: "Filtres", apply: "Appliquer", applied: "Appliqué", reset: "Réinitialiser", clear_all: "Tout effacer",
    loading_dashboard: "Chargement du tableau de bord", no_data: "Aucune donnée", retry: "Réessayer",
    no_rows_match: "Aucune ligne ne correspond aux filtres.", rows: "lignes", of: "sur", page: "Page",
    grand_total: "Total général", total: "Total", target: "Objectif", achieved: "Atteint",
    trend: "Tendance", search: "Rechercher", select_all: "Tout sélectionner", all: "Tous",
    export: "Exporter", refresh: "Actualiser", last_updated: "Dernière mise à jour",
    dashboards: "Tableaux de bord", data_sources: "Sources de données", metrics: "Indicateurs", alerts: "Alertes", reports: "Rapports",
    admin_console: "Console d'administration", developer: "Développeur", settings: "Paramètres", help: "Aide", sign_out: "Se déconnecter",
    sites: "Sites", new_dashboard: "Nouveau tableau de bord", save: "Enregistrer", cancel: "Annuler", close: "Fermer", delete: "Supprimer",
    edit: "Modifier", share: "Partager", publish: "Publier", preview: "Aperçu", back: "Retour", skip_to_content: "Aller au contenu principal",
    clear_filter: "Effacer le filtre", filter: "Filtrer", sort_column: "Trier la colonne", regional_settings: "Paramètres régionaux",
  },
  sw: {
    filters: "Vichujio", apply: "Tumia", applied: "Imetumika", reset: "Weka upya", clear_all: "Futa vyote",
    loading_dashboard: "Inapakia dashibodi", no_data: "Hakuna data", retry: "Jaribu tena",
    no_rows_match: "Hakuna safu zinazolingana na vichujio.", rows: "safu", of: "kati ya", page: "Ukurasa",
    grand_total: "Jumla kuu", total: "Jumla", target: "Lengo", achieved: "Imefikiwa",
    trend: "Mwenendo", search: "Tafuta", select_all: "Chagua vyote", all: "Zote",
    export: "Hamisha", refresh: "Onyesha upya", last_updated: "Sasisho la mwisho",
    dashboards: "Dashibodi", data_sources: "Vyanzo vya data", metrics: "Vipimo", alerts: "Arifa", reports: "Ripoti",
    admin_console: "Dashibodi ya msimamizi", developer: "Msanidi", settings: "Mipangilio", help: "Msaada", sign_out: "Ondoka",
    sites: "Tovuti", new_dashboard: "Dashibodi mpya", save: "Hifadhi", cancel: "Ghairi", close: "Funga", delete: "Futa",
    edit: "Hariri", share: "Shiriki", publish: "Chapisha", preview: "Hakiki", back: "Rudi", skip_to_content: "Ruka hadi maudhui makuu",
    clear_filter: "Futa kichujio", filter: "Chuja", sort_column: "Panga safu wima", regional_settings: "Mipangilio ya eneo",
  },
};

export const LANGUAGES = [
  { value: "", label: "Auto (browser)" },
  { value: "en", label: "English" },
  { value: "ar", label: "العربية (Arabic)" },
  { value: "fr", label: "Français (French)" },
  { value: "sw", label: "Kiswahili (Swahili)" },
];

const RTL = new Set(["ar"]);
let LANG = "en";
let DEFAULT_LANG = "";
const listeners = new Set();
// Deferred so callers that sync the language during a render pass (WidgetRenderer) never
// trigger a React "setState while rendering another component" warning in subscribers.
let _pending = false;
const notify = () => {
  if (_pending) return;
  _pending = true;
  const fire = () => { _pending = false; listeners.forEach((fn) => { try { fn(LANG); } catch { /* ignore */ } }); };
  if (typeof queueMicrotask === "function") queueMicrotask(fire); else setTimeout(fire, 0);
};
const norm = (l) => { const k = String(l || "").slice(0, 2).toLowerCase(); return DICTS[k] ? k : ""; };
const browserLang = () => norm(typeof navigator !== "undefined" ? navigator.language : "") || "en";

// Effective regional default (user > tenant > platform). Empty = browser.
export function setDefaultLanguage(l) {
  DEFAULT_LANG = norm(l);
  if (_override) return;
  const next = DEFAULT_LANG || browserLang();
  if (next === LANG) return;
  LANG = next; syncDocument(); notify();
}
let _override = "";
// Dashboard-level override (canvas.language). Empty = fall back to the regional default.
export function setLanguage(l) {
  _override = norm(l);
  const next = _override || DEFAULT_LANG || browserLang();
  if (next === LANG) return;
  LANG = next;
  syncDocument();
  notify();
}
function syncDocument() {
  if (typeof document === "undefined") return;
  document.documentElement.lang = LANG;
  document.documentElement.dir = RTL.has(LANG) ? "rtl" : "ltr";
}
export function onLanguageChange(fn) { listeners.add(fn); return () => listeners.delete(fn); }
export function currentLanguage() { return LANG; }
export function isRTL() { return RTL.has(LANG); }

// Item 20: organisation dictionary (tenant_settings.i18n) — overlays the built-in strings so an
// org can say "Outlets" instead of "Sites" or use their own wording per language.
let CUSTOM = {};
export function setCustomDictionary(terms) {
  const next = terms && typeof terms === "object" ? terms : {};
  if (JSON.stringify(next) === JSON.stringify(CUSTOM)) return;
  CUSTOM = next;
  notify();
}
export function customDictionary() { return CUSTOM; }
// Keys an organisation can override, with their built-in wording (used by the dictionary editor).
export const TERM_KEYS = Object.keys(EN);
export function baseTerm(key, lang) { return (DICTS[lang] || EN)[key] ?? EN[key] ?? key; }
export function t(key) { return CUSTOM[key] ?? (DICTS[LANG] || EN)[key] ?? EN[key] ?? key; }
